import React from "react";

import { valueStrings } from "constants/constantStrings";

import DupontDialog from "components/DupontDialog";

import "./index.scss";

export default function TableDialog({ popupData, closePopup, colWidth }) {
  const { title, subTitle, rowData } = popupData;
  return (
    <DupontDialog open title={title} subTitle={subTitle} cancelBtnText={valueStrings.close} onClose={closePopup}>
      <div className="table_popup_container">
        {rowData.map((col, idx) => (
          <div className="dialog-row" key={idx}>
            <label className={`col-name ${colWidth}`}>{col.colName}</label>
            <label className="col-value">{col.colVal?.toString()}</label>
          </div>
        ))}
      </div>
    </DupontDialog>
  );
}
